/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_Status_IdleInputs */



/**
* | output |
* | --- |
* | "Idle" |
*
* @param {Live_Caption_Status_IdleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_status_idle = /** @type {((inputs?: Live_Caption_Status_IdleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_Status_IdleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Inactif")
	if (locale === "de") return /** @type {LocalizedString} */ ("Leerlauf")
	if (locale === "it") return /** @type {LocalizedString} */ ("Oziare")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Праздный")
	if (locale === "es") return /** @type {LocalizedString} */ ("Inactivo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("闲置的")
	if (locale === "ja") return /** @type {LocalizedString} */ ("アイドル状態")
	if (locale === "hi") return /** @type {LocalizedString} */ ("निठल्ला")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Parado")
	return /** @type {LocalizedString} */ ("Idle")
});